var map = {
	".": 402,
	"./": 402,
	"./index": 402,
	"./index.js": 402,
	"./resources/audio_upload_icon.svg": 746,
	"./resources/clear.png": 646,
	"./resources/confetti.png": 1373,
	"./resources/document_upload_icon.svg": 747,
	"./resources/heart.png": 1374,
	"./resources/images_upload_icon.svg": 748,
	"./resources/poll.png": 751,
	"./resources/rounded-plus-grey-icon.svg": 744,
	"./resources/send-blue-icon.svg": 750,
	"./resources/smiley.png": 749,
	"./resources/sticker.png": 752,
	"./resources/video_upload_icon.svg": 745,
	"./style": 123,
	"./style.js": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1372;